import React from "react";
import EntityForm from "../../EntityForm/EntityForm";

function customEntityToFormValuesMapper({ id, entity }) {
  if (!entity || !id) {
    return {};
  }

  return { ...entity };
}

function getFields(fields) {
  return fields && fields.form && fields.form.sort((a, b) => (a.order > b.order ? 1 : -1));
}

class ServicesForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  handleSubmit = ({ formValues }) => {
    delete formValues.translations;

    this.props.onSubmitEntity({
      id: formValues.id,
      entity: formValues,
    });
  };

  render() {
    const { name, validation, fields, renderers, translation, locale } = this.props.config;
    const {
      id,
      locales,
      entities,
      entity,
      entityError,
      entityResult,
      entityName,
      loading,
      getListPath,
      relatedEntities,
      updateEntity,
    } = this.props;
    const { handleSubmit } = this;

    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        entityName={entityName}
        getListPath={getListPath}
        entityToFormValuesMapper={props =>
          customEntityToFormValuesMapper({ id: parseInt(id), ...props })
        }
        relatedEntities={relatedEntities}
        locale={locale}
        updateEntity={updateEntity}
      />
    );
  }
}

ServicesForm.propTypes = {};

ServicesForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
  getListPath: function getListPath({ hotelTicker, entityName }) {
    return `/${hotelTicker}/${entityName}/`;
  },
};

export default ServicesForm;
